import { TitleH2, TitleH3 } from "@/components/shared/public";
import { PropsWithChildren } from "react";

const Section = ({
  title,
  topic,
  children,
}: PropsWithChildren<{ title?: string; topic?: string }>) => {
  return (
    <div className="text-ring flex flex-col gap-5">
      {title && <TitleH2 title={title} />}
      {topic && <TitleH3 title={topic} />}
      {children}
    </div>
  );
};

export default Section;
